import { environment } from 'src/environments/environment';

export const { url_backend, url_servicios, url_frontend, url_media } =
  environment;
